
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivals/search",
      function () {
        return require("private-next-pages/rivals/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivals/search"])
      });
    }
  